import Axios, {AxiosInstance, AxiosPromise} from 'axios';
import ApiService from './apiService';
import BioAdmin from 'types/ba/bioAdmin';

export const BioSearchServiceAxiosInstance: AxiosInstance = Axios.create({
	baseURL: window.lt.api.ltApiUrl,
	headers: {
		'apiKey': window.lt.api.biosApiKey,
	},
});

export default class BioSearchService extends ApiService implements BioAdmin.IBioSearchService {
	constructor() {
        super('bio-search-service', BioSearchServiceAxiosInstance);
    }

	public getBioSearch(searchString: string, location: number, role: string): AxiosPromise<BioAdmin.ITeamMemberListProfile[]> {
		let parameters: string = '?limit=100';
		if (searchString) {
			parameters = parameters + '&searchString=' + encodeURIComponent(searchString);
		}
		if (location) {
			parameters = parameters + '&location=' + location;
		}
		if (role) {
			parameters = parameters + '&role=' + encodeURIComponent(role);
		}
		return this.axiosInstance.get('/aem/bios/v1/teamMemberSearch' + parameters);
	}
}
